var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"domain-ui-heating-system-health",style:(_vm.style)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.meta.label))]},null,_vm.meta)],2)}
var staticRenderFns = []

export { render, staticRenderFns }